module.exports = __webpack_public_path__ + "img/ecommerce-app.675e88dd.jpg";